import { DetailCard } from "src/components/Details/Details";
import { FaUserInjured } from "react-icons/fa6";
import { TbUserPlus } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { Patient } from "src/types";

interface RecipientPatientsCardProps {
    patients: Patient[];
    onAddPatient: () => void;
    onEditPatient: (patient: Patient) => void;
}

export function RecipientPatientsCard({
    patients,
    onAddPatient,
    onEditPatient,
}: RecipientPatientsCardProps) {
    const { t } = useTranslation();

    return (
        <DetailCard
            title={<><FaUserInjured /> {t("recipientPage.patientsCard")} ({patients.length})</>}
            full
        >
            <div className="recipient-patients-card__actions">
                <button type="button" className="recipient-action-btn recipient-action-btn--indigo" onClick={onAddPatient}>
                    <TbUserPlus /> {t("recipientPage.addPatient")}
                </button>
            </div>
            {!patients.length ? (
                <div className="empty-state">
                    {t("recipientPage.noPatients")}
                </div>
            ) : (
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th>{t("recipientPage.colName")}</th>
                            <th>{t("recipientPage.colBirthDate")}</th>
                            <th>{t("recipientPage.colEmail")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {patients.map((p) => (
                            <tr
                                key={p.id}
                                className="clickable-row"
                                onClick={() => onEditPatient(p)}
                            >
                                <td>
                                    {p.firstName} {p.lastName}
                                </td>
                                <td>{p.birthDate ? new Date(p.birthDate).toLocaleDateString() : "-"}</td>
                                <td>{p.email ?? "-"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </DetailCard>
    );
}
